<template>
    <section>
        <header class="mb-3 flex items-center gap-2 px-1">
            <span class="h-2.5 w-2.5 shrink-0 rounded-full" :class="style.dot"></span>
            <span class="text-xs font-bold tracking-wide text-gray-text uppercase">{{ label }}</span>
            <span class="rounded-full px-1.5 text-xs font-semibold" :class="style.pill">{{ items.length }}</span>
        </header>

        <div class="flex flex-col gap-3">
            <external-work-order-list-item
                v-for="item in items"
                :key="item.id"
                :work-order="item"
                :active="item.id === selectedId"
                @select="$emit('select', $event)"
            />
        </div>
    </section>
</template>

<script setup>
import { computed } from 'vue';
import ExternalWorkOrderListItem from '@/Pages/WorkOrders/ExternalWorkOrderListItem.vue';

defineEmits(['select']);

const props = defineProps({
    label: {
        type: String,
        required: true,
    },
    status: {
        type: String,
        default: '',
    },
    items: {
        type: Array,
        default: () => [],
    },
    selectedId: {
        type: [String, Number, null],
        default: null,
    },
});

// gray (not started) → amber (active) → green (done)
const STATUS_STYLES = {
    to_do: { dot: 'bg-gray-text', pill: 'bg-gray-text/10 text-gray-text' },
    in_progress: { dot: 'bg-warning', pill: 'bg-warning/20 text-gray-text' },
    done: { dot: 'bg-green', pill: 'bg-green/10 text-green' },
};

const style = computed(() => STATUS_STYLES[props.status] ?? STATUS_STYLES.to_do);
</script>
